export default __webpack_public_path__ + "static/whatsappBusinessPartner-c166e6692c2b3f0f4752bbcdada8b664.png";